import 'whatwg-fetch';
import { getConfigs, setConfigs } from './store.conf';
import { getCredentialsHeader } from '../utils/base.utils';

export const FLAGS = {
    REPLACE_MP_MANAGER_DASHBOARD: 'replace_mp_manager_dasboard',
    REPLACE_MP_MANAGER_DASHBOARD_NON_SELFSERVE: 'replace_mp_manager_dasboard_for_non_selfserve',
    GLOBAL_HEADER_ENABLED: 'global_header_enabled',
    PROGRAM_MANAGER_ENABLED: 'program_manager_enabled',
    QUOTE_VERSION_DETAILS_NEW_DESIGN_FLAG: 'quotes_enable_quote_version_details_new_design'
}

const getFlagsSessionStorageKey = (partner) => {
    return `universal_header_flags_${partner}`;
};

const getFlagsFromSessionStorage = (partner) => {
    try {
        const key = getFlagsSessionStorageKey(partner);
        const cachedFlags = sessionStorage.getItem(key);
        return cachedFlags ? JSON.parse(cachedFlags) : null;
    } catch (error) {
        console.warn('Error reading flags from session storage:', error);
        return null;
    }
};

const setFlagsToSessionStorage = (flags, partner) => {
    try {
        const key = getFlagsSessionStorageKey(partner);
        sessionStorage.setItem(key, JSON.stringify(flags));
    } catch (error) {
        console.warn('Error storing flags to session storage:', error);
    }
};

const getFlags = (defaultPartner) => {
	const { marketUrlApi, partner } = getConfigs();
    const content = {
        "entities": [
            {
                "entityContext":{
                    "tenant": partner || defaultPartner
                }
            }
        ],
        "flagKeys": [
            FLAGS.REPLACE_MP_MANAGER_DASHBOARD,
            FLAGS.PROGRAM_MANAGER_ENABLED,
            FLAGS.REPLACE_MP_MANAGER_DASHBOARD_NON_SELFSERVE,
            FLAGS.GLOBAL_HEADER_ENABLED,
            FLAGS.QUOTE_VERSION_DETAILS_NEW_DESIGN_FLAG
        ]
    }
	const apiUrl = `${marketUrlApi || window.location.origin}/api/appconfigr/v1/evaluation/flagbatch`;
	return fetch(apiUrl, {
        method: 'POST',
        body: JSON.stringify(content),
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: getCredentialsHeader(),
        cache: 'no-store' 
    }).then(resp => resp.ok ? resp.json() : undefined);
};

export default function initFlag(defaultPartner) {
	return new Promise((resolve) => {
        const { partner } = getConfigs();
        
        // First, try to get flags from session storage
        const cachedFlags = getFlagsFromSessionStorage(partner);
        
        if (cachedFlags) {
            // Use cached flags and resolve immediately
            setConfigs({ flags: cachedFlags });
            resolve();
            return;
        }

        // If no cached flags, fetch from API
		getFlags(defaultPartner).then((results) => {
            if(results && results.evaluationResults) {
                const flags = results.evaluationResults.reduce((acc, flag) => {
                    if(flag.flagKey) {
                        acc[flag.flagKey] = flag.variant;
                    }
                    return acc;
                }, {});
                
                // Store flags in both session storage and config store
                setFlagsToSessionStorage(flags, partner);
                setConfigs({ flags });
            }
			resolve();
		})
		.catch(() => {
			resolve();
		});
	});
}
